import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonuses" className="w-full scroll-mt-6 bg-ivory py-10 sm:py-12" aria-labelledby="bonuses-heading" data-id="element-16" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-6xl px-6" data-id="element-17" data-mp="qu2xedxwt2fj">
        <SectionHeading eyebrow="A complete teaching arsenal" eyebrowTone="gold" title={<span id="bonuses-heading" data-id="element-19" data-mp="14rhrvx30s0ed">6 strategic bonuses included</span>} lead="The volumes solve what to teach. These six solve the daily friction — quick starts, project choice, empty supply closets, reflection, and clear on-screen instructions." data-id="element-18" data-mp="qt045zd46nwg" />

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="19kt1u734oxai">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col overflow-hidden rounded-3xl border border-line bg-shell shadow-soft" data-id="element-21" data-mp="1nkbursndc228">
              {/* Cover mockups sit whole on a paper panel — never cropped. */}
              <div className="flex items-center justify-center bg-sand px-6 py-5" data-id="element-22" data-mp="3tr5fi0mbe3rw">
                <img src={bonus.image} alt={bonus.alt} className="h-48 w-auto max-w-full object-contain sm:h-52" width={1232} height={1232} sizes="(max-width: 640px) 80vw, 300px" loading="lazy" decoding="async" data-id="element-23" data-mp="2lvy2xcdyxtw" />
              </div>

              <div className="flex min-w-0 flex-1 flex-col p-5" data-id="element-24" data-mp="lcdlqnid338e">
                <div className="flex items-baseline justify-between gap-3" data-id="element-25" data-mp="le6ty78mhvii">
                  <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-ink" data-id="element-26" data-mp="q9vnntxyoi6w">
                    Bonus {bonus.number}
                  </p>
                  <p className="font-sans text-[10px] uppercase tracking-[0.14em] text-stone" data-id="element-27" data-mp="108l5jmpuy2n5">
                    {bonus.pages}
                  </p>
                </div>

                <h3 className="mt-2 font-display text-lg leading-snug text-ink" data-id="element-28" data-mp="5m5vmgttjpot">
                  {bonus.title}
                </h3>
                <p className="mt-2 font-sans text-[0.85rem] leading-snug text-terracotta-deep" data-id="element-29" data-mp="kc3lr2bb6pgn">
                  {bonus.promise}
                </p>

                <ul className="mt-auto flex flex-wrap gap-1.5 pt-4" data-id="element-30" data-mp="fih5l05xs3g3">
                  {bonus.tags.map(tag => <li key={tag} className="rounded-full bg-sand px-2.5 py-1 font-sans text-[10.5px] text-stone" data-id="element-31" data-mp="ocvvrxs08ydz">
                      {tag}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}